import { OxySelector } from "@/oxygen/classes/lib/types";

/*
 * Changes made here should be reflected in replaceAmpersandInSelector in the breakdance-oxygen/selectors.php file
 */
export function replaceAmpersandInSelector(selector: OxySelector) {
  const replacement =
    selector.type === "class" ? `.${selector.name}` : selector.name;

  return {
    ...selector,
    children: selector.children?.map(child => {
      // Implicitly add an ampersand to the beginning of the name
      const name = child.name.includes("&") ? child.name : `& ${child.name}`;

      return {
        ...child,
        name: name.replace(/&/g, replacement)
      };
    })
  };
}
